import { render, staticRenderFns } from "./JBProposalKeysAndSpecialProtectionMeans.vue?vue&type=template&id=5cb44fc4"
import script from "./JBProposalKeysAndSpecialProtectionMeans.vue?vue&type=script&lang=js"
export * from "./JBProposalKeysAndSpecialProtectionMeans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports